import React, { useState } from "react";
import CustomerApp from "./pages/CustomerApp";
import AdminApp from "./pages/AdminApp";
import "./App.css";

function App() {
  const isAdmin = window.location.pathname === "/admin";

  return isAdmin ? <AdminApp /> : <CustomerApp />;
}

export default App;